<template>
  <div>
    <f7-progressbar v-if="isLoading" infinite color="green" class="progressbar-top"></f7-progressbar>
    <f7-list
      v-if="isLoading"
      class="skeleton-text skeleton-effect-wave"
      key="simHlrInfoLoadSkeleton"
    >
      <f7-list-item v-for="n in 4" :key="n" header="Header" title="Title"></f7-list-item>
    </f7-list>

    <f7-block v-else-if="!isLoading && isNoData">
      <p>{{ $t('NoDataFound') }}</p>
    </f7-block>

    <f7-list v-else no-hairlines class="no-margin-top">
      <f7-list-item
        v-for="(item, index) in hlrList"
        :key="`key-hlr-${index}`"
        :title="item.value"
        :header="item.displayAs"
      ></f7-list-item>
    </f7-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { QTAPI } from "../../../../services/qt-api";

export default {
  name: "sim-hlr-info",

  data() {
    return {
      isLoading: false,
      isNoData: false,
      hlrList: []
    };
  },

  computed: {
    ...mapGetters(["TargetAsset"])
  },

  mounted() {
    this.getHlrInfo();
  },

  methods: {
    async getHlrInfo() {
      this.isLoading = true;
      let result = await QTAPI.GetHLRInfo({ imsi: this.TargetAsset.SimNO });
      this.isLoading = false;
      if (!result) {
        this.isNoData = true;
        return;
      }

      let resList = [
        {
          name: "IMSI", //hlr name
          value: "",
          displayAs: this.$t("IMSI")
        },
        {
          name: "MSISDN", //hlr name4
          value: "",
          displayAs: this.$t("MSISDN")
        },
        {
          name: "VLR Number", //hlr name2
          value: "",
          displayAs: this.$t("VisitorLocationRegister")
        },
        {
          name: "PS Registration Time", //hlr name1
          value: "",
          displayAs: this.$t("DataConnectUpTime")
        },
        {
          name: "CS Registration Time", //hlr name3
          value: "",
          displayAs: this.$t("SMSConnectUpTime")
        },
        {
          name: "MME Realm", //hlr name5
          value: "",
          displayAs: this.$t("EPCMMERealm")
        },
        {
          name: "SGSN Number", //hlr name5
          value: "",
          displayAs: this.$t("SGSN Number")
        }
      ];
      let arr1 = [0, 1, 2, 6];
      let arr2 = [3, 4];
      let arr3 = [5];

      for (const element of arr1) {
        let obj = result.hlrInfoFields.find(
          el => el.name === resList[element].name
        );
        resList[element].value = !obj || !obj.value ? this.$t("na") : obj.value;
      }
      for (const element of arr2) {
        let dataStr = result.hlrInfoFields.find(
          el => el.name === resList[element].name
        )?.value;
        resList[element].value =
          !dataStr || dataStr === "00000000000000"
            ? ""
            : dataStr.slice(0, 4) +
              "-" +
              dataStr.slice(4, 6) +
              "-" +
              dataStr.slice(6, 8) +
              " " +
              dataStr.slice(8, 10) +
              ":" +
              dataStr.slice(10, 12) +
              ":" +
              dataStr.slice(12, 14);
      }
      for (const element of arr3) {
        let obj = result.dataMap.find(el => el.key === resList[element].name);
        resList[element].value = !obj || !obj.value ? this.$t("na") : obj.value;
      }
      this.hlrList = resList;
    }
  }
};
</script>

<style scoped>
</style>